__turbopack_context__.v({
  "bar": "-D6QdW_bar",
  "barInner": "-D6QdW_barInner",
  "compactTitle": "-D6QdW_compactTitle",
  "innerDesktop": "-D6QdW_innerDesktop",
  "innerMobile": "-D6QdW_innerMobile",
  "toggleSlot": "-D6QdW_toggleSlot",
});
